import "@/assets/vendor/nucleo/css/nucleo.css";
import "@/assets/vendor/font-awesome/css/font-awesome.css";
import "@/assets/scss/argon.scss";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import VueLazyload from "vue-lazyload";

import VueLoading from "vue-component-loading";
import SessionInstance from "../api/session";
import VueAxios from "vue-axios";

import VueCookies from "vue-cookies";

//import VueAuthenticate from "vue-authenticate";
import PopoverPlugin from 'bootstrap-vue';
import VueWait from 'vue-wait';

let vueLoadingConfig = {
  progressBar:{
    color: '#fff',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
      speed: '0.2s',
      opacity: '0.6s',
      termination: 300
    },
  }
};

const COOKIE_DEFAULT_EXPIRES = 60 * 60 * 2;
VueCookies.config(COOKIE_DEFAULT_EXPIRES);

/*let VueAuthenticateConfig = {
    baseUrl: SessionInstance.defaults.baseURL,
    tokenPrefix: '',
    tokenName: 'token',
    tokenPath: 'key',
    loginUrl: '/auth/login/',
    logoutUrl: '/auth/logout/',
    registerUrl: '/auth/registration/',
    storageNamespace: '',
    providers: {
        google: {
          clientId: '1051463993687-csv7fodnqb2r4ash8kh54roglg528dq6.apps.googleusercontent.com',
          url: '/auth/social/google/login/'
        },
        facebook: {
          clientId: '845937585764539',
          url: '/auth/social/facebook/login/'
        }
    }
};
*/

export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(VueLazyload);
    Vue.use(PopoverPlugin);
    Vue.use(VueLoading, vueLoadingConfig);
    Vue.use(VueAxios, SessionInstance);
    Vue.use(VueWait);
    Vue.use(VueCookies);
    //Vue.use(VueAuthenticate, VueAuthenticateConfig);
  }
};
